var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8922 6.79959C8.34418 6.75661 5.70889 8.53727 4.05212 10.3609C3.87822 10.554 3.78198 10.8046 3.78198 11.0645C3.78198 11.3243 3.87822 11.5749 4.05212 11.768C5.67286 13.5531 8.30056 15.3748 10.8922 15.3312C13.4839 15.3748 16.1122 13.5531 17.7342 11.768C17.9081 11.5749 18.0044 11.3243 18.0044 11.0645C18.0044 10.8046 17.9081 10.554 17.7342 10.3609C16.0756 8.53727 13.4403 6.75661 10.8922 6.79959Z",
    stroke: "#414141",
    strokeWidth: 1.70654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5979 11.0654C12.5978 11.4029 12.4976 11.7328 12.3101 12.0134C12.1225 12.2939 11.8559 12.5126 11.5441 12.6417C11.2323 12.7708 10.8891 12.8045 10.5581 12.7386C10.2271 12.6727 9.9231 12.5102 9.68449 12.2715C9.44587 12.0328 9.28338 11.7287 9.21757 11.3977C9.15176 11.0667 9.18558 10.7236 9.31476 10.4118C9.44394 10.1 9.66267 9.83347 9.9433 9.64597C10.2239 9.45847 10.5538 9.3584 10.8913 9.3584C11.1155 9.35834 11.3375 9.40245 11.5446 9.48822C11.7517 9.57399 11.9399 9.69973 12.0983 9.85826C12.2568 10.0168 12.3825 10.205 12.4682 10.4121C12.5539 10.6192 12.598 10.8412 12.5979 11.0654Z",
    stroke: "#414141",
    strokeWidth: 1.70654,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.1666be93.svg";
export { ForwardRef as ReactComponent };